export enum Role {
  GUEST = 'guest',
  CUSTOMER = 'customer',
  VENDOR = 'vendor',
  ADMIN = 'admin',
}

export interface User {
  id: number;
  email: string;
  fullName: string;
  isVerified: boolean;
  role: Role;
  createdAt: string;
}

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
  tokenType: 'bearer';
  expiresIn: number;
}

export interface AccessTokenPayload {
  sub: string;
  exp: number;
  iat: number;
  jti: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  fullName: string;
  whatsappNumber?: string;
  /** ID document (cédula). Optional; used to link prior guest orders. */
  documentNumber?: string;
  /** Document type: CC, CE, NIT, PA, TI, PEP. */
  documentType?: string;
  termsAccepted: boolean;
}

export interface AuthContextValue {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (credentials: LoginRequest) => Promise<void>;
  register: (data: RegisterRequest) => Promise<void>;
  logout: () => Promise<void>;
  logoutAll: () => Promise<void>;
  refreshUser: () => Promise<void>;
}
